import { BRAND } from "../constant/theme";

export const EXCEL_SIDEBAR_COLOR = `FF${BRAND.navy.replace("#", "")}`;
export const EXCEL_WHITE = "FFFFFFFF";

const thinBorder = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" },
};

const applySidebarStyle = (row, columnCount, alignment) => {
  const totalColumns = columnCount || row.worksheet.columnCount;

  for (let column = 1; column <= totalColumns; column += 1) {
    const cell = row.getCell(column);
    cell.font = {
      ...cell.font,
      bold: true,
      color: { argb: EXCEL_WHITE },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: EXCEL_SIDEBAR_COLOR },
    };
    cell.border = thinBorder;
    cell.alignment = {
      ...cell.alignment,
      vertical: "middle",
      horizontal: alignment,
    };
  }
};

export const styleExcelTitleRow = (row, columnCount) => {
  applySidebarStyle(row, columnCount, "center");
};

export const styleExcelHeaderRow = (row, columnCount) => {
  applySidebarStyle(row, columnCount, "center");
};

export const styleExcelSummaryRow = (row, columnCount) => {
  applySidebarStyle(row, columnCount, "right");
};

export const applyExcelThinBorders = (worksheet) => {
  worksheet.eachRow({ includeEmpty: false }, (row) => {
    row.eachCell({ includeEmpty: false }, (cell) => {
      cell.border = thinBorder;
    });
  });
};
